// extracted by mini-css-extract-plugin
export var container = "index-module--container--Syk6B";
export var linkCont = "index-module--linkCont--70cWQ";
export var subtitleCont = "index-module--subtitleCont--0t5zc";
export var titleCont = "index-module--titleCont--nxrdT";